"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newApi = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _constants = require("./constants.js");

var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse,
      config = _ref.config;
  return {
    getReservationHistory: function () {
      var _getReservationHistory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _historyTabs$ACTIVE$h;

        var _ref2,
            tab,
            start,
            limit,
            driverName,
            registrationNumber,
            response,
            _args = arguments;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, tab = _ref2.tab, start = _ref2.start, limit = _ref2.limit, driverName = _ref2.driverName, registrationNumber = _ref2.registrationNumber;
                _context.next = 3;
                return amsResponse.getRawBody({
                  method: "GET",
                  path: "v1.2/rentcontract/bookinghistory",
                  query: {
                    requestMode: (_historyTabs$ACTIVE$h = {}, (0, _defineProperty2["default"])(_historyTabs$ACTIVE$h, _constants.historyTabs.ACTIVE, "presence"), (0, _defineProperty2["default"])(_historyTabs$ACTIVE$h, _constants.historyTabs.PAST, "history"), _historyTabs$ACTIVE$h)[tab],
                    start: start,
                    limit: limit,
                    drivername: driverName,
                    registrationNumber: registrationNumber
                  }
                });

              case 3:
                response = _context.sent;
                return _context.abrupt("return", {
                  totalCount: response.totalCount,
                  data: response.data || []
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getReservationHistory() {
        return _getReservationHistory.apply(this, arguments);
      }

      return getReservationHistory;
    }()
  };
};

exports.newApi = newApi;